import { render } from "./ConfirmationView.vue?vue&type=template&id=664fc7a4"
import script from "./ConfirmationView.vue?vue&type=script&lang=js"
export * from "./ConfirmationView.vue?vue&type=script&lang=js"

import exportComponent from "/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__